module.exports = __webpack_public_path__ + "static/media/dish_logo_beacon_animated_small.0aa2b9b4.gif";